import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";

import InputRadioField from "../../../../../components/Common/inputRadioField";
import Breadcrumbs from "../../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import BackBtn from "../../../../../components/Common/backBtn";
import InputTextField from "../../../../../components/Common/inputTextField";
import SucessModal from "../../../../../components/Modal/SucessModal";

const InclinicDoctorSpecializationForm = ({ edit = false }) => {
  const [success, setSuccess] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const { id } = useParams();

  useEffect(() => {
    edit && getMenuData();
  }, [edit]);

  const getMenuData = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}inclinc-doctor-specialization/get/${id}`,
      )
      .then((response) => {
        setValue(
          "inclinic_doctor_specialization",
          response.data.inclinic_doctor_specialization,
        );
        setValue("active", response.data.active);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  const onSubmit = (fields) => {
    if (edit) {
      axios
        .patch(
          `${process.env.REACT_APP_API_URL}inclinc-doctor-specialization/update/${id}`,
          {
            ...fields,
            inclinic_doctor_specialization:
              fields?.inclinic_doctor_specialization.trim(),
          },
        )
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    } else {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}inclinc-doctor-specialization/create`,
          {
            ...fields,
            inclinic_doctor_specialization:
              fields?.inclinic_doctor_specialization.trim(),
          },
        )
        .then((response) => {
          if (response.data?._id) {
            setSuccess(true);
          } else {
            alert("Fail");
            console.log("failed...");
          }
        });
    }
  };

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Doctor",
        link: "/partnered-doctor-online",
      },
      {
        text: "In-Clinic Doctor Specialization",
        link: "/inclinic-specialization",
      },
      {
        text: `${edit ? "Edit" : ""} In-Clinic Doctor Specilization`,
        link: "",
      },
    ],
    [],
  );

  return (
    <>
      <Breadcrumbs
        className="healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      <BackBtn navigatePath="/inclinic-specialization" />
      <div className="healtharticle">
        <div className="healtharticle-container">
          <div className="healtharticle-title">
            {/* <Breadcrumbs
              breadcrumbText="Doctor"
              breadcrumbLink=""
              nestedText="In-Clinic Doctor Specialization"
              nestedLink="/inclinic-specialization"
              nestedText2={`${edit ? "Edit" : ""} In-Clinic Doctor Specilization`}
              nestedLink2=""
            /> */}
          </div>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="career-jobpost-form"
          >
            <div className="addnew-form1-autor-detail mt-3 d-flex">
              <div className="col-md-6">
                <InputTextField
                  labelName="In-Clinic Appointment Specialization "
                  name="inclinic_doctor_specialization"
                  register={register}
                  errors={errors}
                  errorText={"Please provide a Inclinic Doctor Specialization"}
                />
              </div>
              <div className="col-md-6">
                <InputRadioField
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                />
              </div>
            </div>
            <div className="car-dep-form-button mt-5 mb-5">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </div>
      {success && (
        <SucessModal
          page={"/inclinic-specialization"}
          name="In-Clinic Doctor Specialisation"
          post={edit ? "updated" : "posted"}
        />
      )}
    </>
  );
};

export default InclinicDoctorSpecializationForm;
